import * as market from './market';
import * as periodicEditions from './periodic-editions';

export const eCommerce = {
  ...market,
  ...periodicEditions,
};
